import { render, staticRenderFns } from "./ResignationTemp.vue?vue&type=template&id=1ba2ecd5&scoped=true&"
import script from "./ResignationTemp.vue?vue&type=script&lang=js&"
export * from "./ResignationTemp.vue?vue&type=script&lang=js&"
import style0 from "./ResignationTemp.vue?vue&type=style&index=0&id=1ba2ecd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba2ecd5",
  null
  
)

export default component.exports